export enum StreetOrientationMode {
  ALL_FACES = "ALL_FACES",
  FRONT_FACES = "FRONT_FACES",
  FRONT_AND_SIDE_FACES = "FRONT_AND_SIDE_FACES",
  FRONT_AND_BACK_FACES = "FRONT_AND_BACK_FACES",
  NO_FACES = "NO_FACES",
}
